import { BotPriceMessage } from '@/types';
import Markdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

type MessagePriceProps = {
  message: BotPriceMessage;
  messageId: string;
};

const MessagePrice = ({ message }: MessagePriceProps) => {
  const { price, currency, shorttext, longtext } = message.content;

  return (
    <>
      <div className="inline-flex items-end gap-2">
        <span className="text-4xl font-bold text-widget-text-primary">{price}</span>
        <span className="text-md font-medium text-widget-text-secondary">{currency}</span>
      </div>
      {shorttext && (
        <p className="text-lg font-bold text-widget-text-primary">
          <Markdown remarkPlugins={[remarkGfm]}>{shorttext}</Markdown>
        </p>
      )}
      {longtext && (
        <p className="text-md text-widget-text-primary">
          <Markdown remarkPlugins={[remarkGfm]}>{longtext}</Markdown>
        </p>
      )}
    </>
  );
};

export default MessagePrice;
